import * as React from 'react';
import { l } from '../../Other/Translation';
import './styles.scss';

export interface MobilePropsInterface {
  language: string;
}

function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

interface BadgeProps { language: string; }

const IOSBadge: React.SFC<BadgeProps> = ({ language }) => {
  const country = language === 'en' ? 'gb' : language;
  const languages = { en: 'EN', fr: 'FR', sv: 'SE', de: 'DE', fi: 'FI' };
  return (
    <a href={`https://apps.apple.com/${country}/app/zervant/id1455614624?utm_source=intercom&amp;utm_medium=email&amp;utm_campaign=mobile_launch`}>
      <img src={`http://www.zervant.com/assets/images/mail/header/AppStore_${languages[language]}.png`} alt="Download on the App Store" />
    </a>
  );
};

const AndroidBadge: React.SFC<BadgeProps> = ({ language }) => {
  return (
    <a href={`https://play.google.com/store/apps/details?id=com.zervant.invoicing&hl=${language}`}>
      <img style={{ height: '60px' }} alt="Get it on Google Play"
        src={`https://play.google.com/intl/en_us/badges/images/generic/${language}_badge_web_generic.png`} />
    </a>
  );
};

const supportedLanguages = ['en', 'sv', 'fr', 'fi', 'de', 'nl'];

export class MobileMessage extends React.Component<MobilePropsInterface, any> {

  public render() {
    let { language } = this.props;
    language = supportedLanguages.includes(language.toLowerCase()) ? language : 'en';
    return (
      <div className={'mobileMessage'}>
        <div className="generatorImage"></div>
        <p className="mainText">
          {l('invoiceGenerator.mobile.mainText')}
        </p>
        <p className="subText">
          {l('invoiceGenerator.mobile.subText')}
        </p>
        {getMobileOperatingSystem() === 'iOS' ? <IOSBadge language={language} /> : <AndroidBadge language={language} />}

      </div >
    );
  }
}

export default MobileMessage;
